module.exports = __webpack_public_path__ + "img/wunder.6733e4f2.jpg";